export const FavoriteBorder = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="m5.635 10.154-.001-.001C4.074 8.739 2.84 7.62 1.987 6.578 1.142 5.546.75 4.683.75 3.797A2.517 2.517 0 0 1 3.3 1.25c.817 0 1.613.384 2.13.99l.57.669.57-.67A2.845 2.845 0 0 1 8.7 1.25a2.517 2.517 0 0 1 2.55 2.547c0 .886-.392 1.75-1.237 2.782-.853 1.042-2.086 2.163-3.646 3.58h-.001l-.364.329-.367-.334z"
			fill="#fff"
			stroke="#7EA6B4"
			stroke-width="1.5"
		/>
	</svg>
);
export const FavoriteIcon = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="m5.635 10.154-.001-.001C4.074 8.739 2.84 7.62 1.987 6.578 1.142 5.546.75 4.683.75 3.797A2.517 2.517 0 0 1 3.3 1.25c.817 0 1.613.384 2.13.99l.57.669.57-.67A2.845 2.845 0 0 1 8.7 1.25a2.517 2.517 0 0 1 2.55 2.547c0 .886-.392 1.75-1.237 2.782-.853 1.042-2.086 2.163-3.646 3.58h-.001l-.364.329-.367-.334z"
			fill="#367BF5"
			stroke="#367BF5"
			stroke-width="1.5"
		/>
	</svg>
);
